import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import createEvent from '@/scripts/utils/create-event';
import Controller from '@/scripts/utils/scrollmagic/controller';
import ScrollMagic from 'scrollmagic';
import 'animation.gsap';
import selectors from './animation-selectors';

import animatedComponents from './animated-elements';
import addToTimeLine from './add-element-to-timeline';

export default class {
  constructor(section) {
    this.section = section;
    this.triggerElement = selectors.section;
    this.Scene = new ScrollMagic.Scene({
      triggerElement: this.section,
      triggerHook: 'onEnter',
      offset: this.section.dataset.triggerOffset || selectors.offset,
      duration: section.clientHeight + selectors.offset * 2,
    });
    this.tlSet = new TimelineMax();
    this.tlAnimate = new TimelineMax({
      paused: true,
      force3D: true,
      onComplete: () => {
        const fadeSliderContainer = this.section.querySelector(selectors.fadeSlider);
        if (fadeSliderContainer) {
          setTimeout(() => {
            fadeSliderContainer.dispatchEvent(createEvent('fade-slider-start'));
          }, 5000);
        }
      },
    });

    this.add = addToTimeLine.bind(this);
  }

  set() {
    animatedComponents.forEach((component) => {
      this.add(component.trigger, component.set.bind(this), component.animate.bind(this));
    });
  }

  animate() {
    this.section.classList.add('is-animated');
    TweenMax.to(this.tlAnimate, 1, { progress: 1 });
    // this.tlAnimate.play();
  }

  startEvent() {
    this.section.dispatchEvent(createEvent(selectors.sectionEventStart));
  }
  stopEvent() {
    this.section.dispatchEvent(createEvent(selectors.sectionEventStop));
  }
  init() {
    this.set();
    this.Scene.on('enter', this.startEvent.bind(this));
    this.Scene.on('leave', this.stopEvent.bind(this));
    this.Scene.setTween(this.animate.bind(this));
    this.Scene.addTo(Controller);
    // this.Scene.addIndicators({ name: 'Section animation' });
  }

  destroy() {
    this.Scene.destroy();
  }
}



// WEBPACK FOOTER //
// ./scripts/animation/section.js